import React, { useContext } from 'react';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { AuthContext } from 'context/AuthContext';
import { useAppContext, useStoreConnect } from 'utils/hooks';
import { ReactComponent as AddIcon } from 'assets/img/icons/add.svg';

export default function ConnectStoreOption() {
  const { isSSRMode } = useAppContext();
  const { onOpen } = useStoreConnect();
  const { roles } = useContext(AuthContext);

  const isAdmin = _get(roles, 'admin', false);

  if (isSSRMode || !isAdmin) return null;

  return (
    <UiKit.Dropdown.Option onClick={onOpen}>
      <AddIcon className={styles.icon} />
      Connect New Store
    </UiKit.Dropdown.Option>
  );
}
